import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
// Redux
import { useDispatch } from "react-redux";
import { validateLogin } from "../../redux/userDucks";
import { setDataBaseEnvironment } from "../../redux/dbDucks";
// Constants
import { pathHomePage, roleAccess, WEB_SERVICE_DASHBOARD_ROUTE } from "../../config/constants";
// Components
import {
  LoginContainer,
  LogoMimsImg,
  LogoSeparator,
  Form,
  LoginForm,
  Label,
  Input,
  TextInput,
  FieldSeparator,
  ButtonSubmit,
} from "./styles";
// Assets
import EodyneLogo from "../../assets/logo_eodyne.svg";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [redirectTo, setRedirectTo] = useState("");
  const dispatch = useDispatch();

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleLogin(e);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (username === "" || password === "") return toast.error("Debes ingresar el usuario y la contraseña");

    setIsLoggingIn(true);
    try {
      const { data } = await axios.post(`${WEB_SERVICE_DASHBOARD_ROUTE}/auth/login`, {
        USERNAME: username,
        PASSWORD: password,
      });

      const access = roleAccess[data.user.role];
      if (!access) return toast.error("El usuario no tiene un rol valido");

      dispatch(validateLogin(data));
      // Solo ADMIN y GUEST eligen entorno; el resto lo tienen fijado.
      if (access.environment) dispatch(setDataBaseEnvironment(access.environment));

      return setRedirectTo(`${pathHomePage}${access.landingPage}`);
    } catch (error) {
      const message = error.response && error.response.data && error.response.data.message;
      return toast.error(message || "No se ha podido iniciar sesion");
    } finally {
      setIsLoggingIn(false);
    }
  };

  if (redirectTo) {
    return <Redirect to={redirectTo} />;
  }

  return (
    <LoginContainer>
      <LoginForm>
        <LogoMimsImg src={EodyneLogo} alt="logo-mims" />
        <LogoSeparator />
        <Form onSubmit={handleLogin} autoComplete="off">
          <Label>Usuario</Label>
          <TextInput
            type="text"
            placeholder="usuario"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onKeyPress={handleKeyPress}
            autoComplete={"off"}
          />
          <FieldSeparator />
          <Label>Contraseña</Label>
          <Input
            type="password"
            placeholder="****"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={handleKeyPress}
            autoComplete={"new-password"}
          />
          <ButtonSubmit type="submit" disabled={isLoggingIn}>
            {isLoggingIn ? "Entrando..." : "Entrar"}
          </ButtonSubmit>
        </Form>
      </LoginForm>
    </LoginContainer>
  );
};

export default Login;
